export const Endpoint = () => `/api/v3/admin/subscriptions`;
export const QueryKey = (userId: string) => ['v3', 'admin', 'reports', 'user-subscriptions', userId] as const;

export interface Payload {
    userid: string;
}

export interface DeliveryObject {
    deliveryType: string;
    deliveryAddress: string;
}

export interface SubscriptionDetail {
    query: string;
    crontab: string;
    subscribers: string;
    deliveryObjects: DeliveryObject[];
}

export interface Response {
    subscriptionCount?: number;
    subscribersCount?: number;
    details?: SubscriptionDetail[];
}
